<template>
  <div :class="['v-input', !!value && 'v-input--filled']">
    <label class="v-input__wrapper">
      <input class="v-input__input" v-bind="$attrs" v-model="value" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />
      <span class="v-input__label">{{placeholder}}</span>
    </label>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  data() {
    return {
      value: this.$attrs.value
    };
  },
  props: {
    placeholder: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-input {
  &__wrapper {
    display: flex;
    position: relative;
  }

  &__label {
    position: absolute;
    z-index: 1;
    top: 13px;
    left: 7px;
    color: #939393;
    background: #fff;
    padding: 0 5px;
    transition: all 200ms ease-out;
    cursor: text;
    pointer-events: none;

    .v-input--filled & {
      font-size: 0.75rem;
      transform: translateY(-25px);
    }
  }

  &__input {
    width: 100%;
    height: 50px;
    padding: 0 10px;
    border: 1px solid #b8b8b8;
    border-radius: 5px;
    font-size: 1rem;
    background: #fff;
    line-height: 1em;
    transition: all 200ms ease-out;
    font-family: "Lota Grotesque", Arial, Helvetica, sans-serif;

    &:focus ~ .v-input__label {
      font-size: 0.75rem;
      transform: translateY(-25px);
      background: #fff;
      color: #0084ff;
    }

    &:focus {
      outline: 0;
      border-color: #0084ff;
      box-shadow: 0 0 0 1px #0084ff;
    }
  }
}
</style>
